var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.variantClass,attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click-handler')}}},[_vm._t("default",[_vm._v(" Click ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }